import classNames from "classnames";
import React, { PropsWithChildren } from "react";

export type StarburstIconContentColor = "pink" | "yellow";

interface StarburstIconProps {
  /** Changes the colour of text within an icon to either pink or yellow. */
  textColor?: StarburstIconContentColor;
}

export const StarburstIcon: React.FC<PropsWithChildren<StarburstIconProps>> = ({
  textColor,
  children,
}) => {
  const starburstIconClasses = classNames("starburst__icon", {
    [`text__colour--${textColor}`]: textColor,
  });

  return (
    <div>
      <section title="Starburst icon" className={starburstIconClasses}>
        {children}
      </section>
    </div>
  );
};
